// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"Reports_maincontainer__1Jvz5","heading":"Reports_heading__1Oqte","gridholder":"Reports_gridholder__31Fqu","gridcontainer":"Reports_gridcontainer__21ymI"};